import React from 'react';

import IconGripVertical from '@zvuk-b2b/react-uikit/ui/icons/GripVertical';
import classNames from 'classnames';
import styles from './index.module.scss';

type DraggableListItemProps = React.PropsWithChildren<{
  dragHandleTestId?: string;
  isDraggable?: boolean;
}>;

export const DraggableListItem: React.FC<DraggableListItemProps> = ({
  children,
  dragHandleTestId,
  isDraggable = true,
}) => (
  <div className={styles.wrapper}>
    <div
      className={styles.iconWrapper}
      data-testid={dragHandleTestId}>
      {isDraggable && <IconGripVertical className={classNames(styles.icon, 'draggable')} />}
    </div>
    <div className={styles.childrenWrapper}>{children}</div>
  </div>
);
